// Role-aware navigation + page gating.
// Mirrors the backend permission matrix (see backend/auth/dependencies.py).
import {
  BarChart3, Phone, Users, Settings, TrendingUp, History, Volume2,
  Bot, Shield, Calendar, PhoneIncoming, Ticket, FileText,
  Package, CheckSquare, MessageSquare,
} from 'lucide-react';

// Page id → which roles can see it. `null` means "all authenticated users".
// Phase Audit Fix C: workflows + integrations pages removed.
const PAGE_ROLES = {
  dashboard: null,
  campaigns: null,
  leads: null,
  calendar: null,
  'inbound-calls': null,
  tickets: null,
  agents: null,
  'voice-library': null,
  'call-history': null,
  tasks: null,
  'sms-automation': null,  // visible to all authenticated; backend gates writes
  analytics: ['platform_admin', 'dealer_owner', 'dealer_manager'],
  reports: ['platform_admin', 'dealer_owner', 'dealer_manager'],
  settings: ['platform_admin', 'dealer_owner', 'dealer_manager'],
  admin: ['platform_admin', 'dealer_owner'],
  inventory: null,  // all authenticated users can view; edit gating is server-side
};

const NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: BarChart3 },
  { id: 'campaigns', label: 'Campaigns', icon: Phone },
  { id: 'leads', label: 'Leads', icon: Users },
  { id: 'calendar', label: 'Calendar', icon: Calendar },
  { id: 'inbound-calls', label: 'Inbound Calls', icon: PhoneIncoming },
  { id: 'tickets', label: 'Tickets', icon: Ticket },
  { id: 'agents', label: 'AI Agents', icon: Bot },
  { id: 'voice-library', label: 'Voice Library', icon: Volume2 },
  { id: 'call-history', label: 'Call History', icon: History },
  { id: 'tasks', label: 'Tasks', icon: CheckSquare },
  { id: 'sms-automation', label: 'SMS Automation', icon: MessageSquare },
  { id: 'inventory', label: 'Inventory', icon: Package },
  { id: 'analytics', label: 'Analytics', icon: TrendingUp },
  { id: 'reports', label: 'Reports', icon: FileText },
  { id: 'admin', label: 'Admin', icon: Shield },
  { id: 'settings', label: 'Settings', icon: Settings },
];

export function isPageAllowed(pageId, role) {
  if (!(pageId in PAGE_ROLES)) return true;
  const allowed = PAGE_ROLES[pageId];
  if (allowed === null) return true;
  return allowed.includes(role);
}

export function navItemsForRole(role) {
  return NAV.filter((item) => isPageAllowed(item.id, role));
}

export const ROLE_LABELS = {
  platform_admin: 'Platform Admin',
  dealer_owner: 'Dealer Owner',
  dealer_manager: 'Dealer Manager',
  salesperson: 'Salesperson',
};
